export const payers = {
    Audrey: 'Audrey',
    Morgan: 'Morgan'
};
export const CONF_SPENDING_ID = 'conf-spendings';
